
define('known/knownUtil',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/collections/productCollection',
	'known/collections/leagueInstanceCollection',
	'known/views/userHeaderView',
	'known/views/sideNavView',
	'module',
	
	//Shims
	'jquery.uniform'
], function($, _, Backbone, UserModel, ProductCollection, LeagueInstanceCollection, UserHeaderView, SideNavView, module){
	var util = {};
	
	util.userModel = null;
	util.prodCollection = null;
	util.leagueCollection = null;
	util.updateCollections = function(){
		if(!util.userModel.isGuest()){
			util.leagueCollection.userName = util.userModel.get('userName');
			util.prodCollection.userName = util.userModel.get('userName');
			
			util.leagueCollection.trigger("userChange");
			util.prodCollection.trigger("userChange");
		}
	};
	
	var initialize = function(){
		var loginStatusJSON = $.parseJSON(module.config().loginStatusJSON);
		var userJSON = $.parseJSON(module.config().userJSON);
		var productsJSON = $.parseJSON(module.config().productsJSON);
		var userLeaguesJSON = $.parseJSON(module.config().userLeaguesJSON);
		
		
		//Initialize collapsible side navigation
		$('.expand').collapsible({
			cssClose: 'subClosed',
		    cssOpen: 'subOpened',
		    cookieName: 'navAct',
		    defaultOpen: '',
		    speed: 200
		});
		
		// Hide/Show sidebar
		$('.nav-menu').click(function(){
		    $("body").toggleClass("clean");
		    $('#sidebar').toggleClass("hide-sidebar mobile-sidebar");
		    $('#content').toggleClass("full-content");
		});
		
		//Add styling to checkboxes, dropdowns, and radios
		$(".ui-datepicker-month, .styled, .dataTables_length select").uniform({radioClass: 'choice', selectAutoWidth: false});
		
		//If its a guest, create a special "guest" user, otherwise use the JSON retrieved on page load
		if(loginStatusJSON.userName 
				&& loginStatusJSON.userName != "" 
				&& loginStatusJSON.userName != "guest"){
			util.userModel = new UserModel(userJSON);
			util.userModel.set('envProfile', loginStatusJSON.envProfile);
		} else {
			util.userModel = new UserModel({userName: loginStatusJSON.userName});
		}
		
		util.prodCollection = new ProductCollection(productsJSON, {userName : util.userModel.get("userName")});
		util.leagueCollection = new LeagueInstanceCollection(userLeaguesJSON, {userName : util.userModel.get("userName")});
		
		var userHeaderView = new UserHeaderView({model: util.userModel});
		var sideNavView = new SideNavView({user: util.userModel, prodCollection: util.prodCollection, leagueCollection: util.leagueCollection});
		
		util.userModel.on('change:userName', util.updateCollections);		
		
		userHeaderView.render();
		sideNavView.render();
		
		//Highlight links in sidenav
		var path = window.location.pathname;
		
		if(path == '/draftapp/dashboard/' || path == '/draftapp/dashboard'){
			$('.sideNavDashboardLink').addClass('active');
		} else if(path.indexOf('/draftapp/dashboard/account', 0) > -1){
			$('.sideNavAccountLink').addClass('active');
		}
		
		return {
			userModel: util.userModel,
			prodCollection: util.prodCollection,
			leagueCollection: util.leagueCollection
		};
	};
	
	var setupSideNav = function(){
		$("body").removeClass("collapsibleNav");		
		return initialize();
	};
	
	var setupCollapsibleSideNav = function(){
		return initialize();
	};
	
	return {
		setupSideNav: setupSideNav,
		setupCollapsibleSideNav: setupCollapsibleSideNav
	};
});